'use client';
import { FC } from 'react';

import styled from 'styled-components';

import { SearchURLProvider } from '@api/data-loaders/resource';

import HotelProvider from './context';
import HotelDetail from './HotelDetail';
import { IHotelListingScreen } from '../listing';

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;

const HotelDetailScreen: FC<IHotelListingScreen> = ({ searchData }) => {
  return (
    <SearchURLProvider value={searchData || null}>
      <HotelProvider>
        <Container>
          <HotelDetail />
        </Container>
      </HotelProvider>
    </SearchURLProvider>
  );
};

export default HotelDetailScreen;
